import React, { } from "react";
import { NavLink } from "react-router-dom";
import "./earn.css";

import sandTimer from "../../assets/earnAssets/sandTimer.png";
// import PartnerCard from "../../components/PartnerCard/PartnerCard";
import TaskItem from "../../components/TaskItem/TaskItem";
import CompletedTaskItem from "../../components/TaskItem/CompletedTaskItem";
import earnArrow from "../../assets/earnAssets/earnArrow.svg";
// import PartnerCard from "../../components/PartnerCard/PartnerCard";
// import PartnerCard from "../../components/PartnerCard/PartnerCard";

const Earn = ({ tasks, completedTasks, handleCompleteTask, wodTasks }) => {
  // const [data, setData] = useState([]);

  // const filteredTasks = tasks.filter(
  //   (item) => item.partner !== "daily-opportunities"
  // );
  const filteredCompleted = completedTasks.filter(
    (item) => item.partner !== "daily-opportunities"
  );

  // // Sorting logic
  // useEffect(() => {
  //   const sortedData = [...filteredTasks].filter((item) => {
  //     return item.partner === "world-of-dypians";
  //   });

  //   // setData(sortedData); // Update the state with sorted data
  // }, [filteredTasks]); // Runs only once after the initial render

  //  const dummyTasks = [
  //         {
  //           partner: 'world-of-dypians',
  //           title: 'Watch new WoD Video',
  //           subtitle: 'Watch and earn 500 points',
  //           link: 'https://www.youtube.com/watch?v=VTiIhZcXLSM',
  //           type: 'youtube',
  //           action: 'watch',
  //           secretWord: 'wod the best',
  //           reward: 500,
  //         },
  //         {
  //           partner: 'world-of-dypians',
  //           title: 'Follow WoD on X',
  //           subtitle: 'Follow WoD on X and earn 750 points',
  //           link: 'https://twitter.com/worldofdypians',
  //           type: 'twitter',
  //           action: 'follow',
  //           reward: 700,
  //         },
  //         {
  //           partner: 'world-of-dypians',
  //           title: 'Follow OpenFlux on X',
  //           subtitle: 'Follow OpenFlux on X and earn 750 points',
  //           link: 'https://x.com/OpenFluxNFT',
  //           type: 'twitter',
  //           action: 'follow',
  //           reward: 700,
  //         },
  //         {
  //           partner: 'world-of-dypians',
  //           title: 'Join WoD On Telegram',
  //           subtitle: 'oin WoD On Telegram and earn 500 points',
  //           link: 'https://x.com/OpenFluxNFT',
  //           type: 'telegram',
  //           action: 'join',
  //           groupId: '-1001542536650',
  //           reward: 700,
  //         }
  //       ]



  // const buyWodTasks = tasks.filter((item) => {
  //   return item.type === "buy_wod" && item.partner === "world-of-dypians";
  // });
  // const completedBuyWodTasks = completedTasks.filter((item) => {
  //   return item.type === "buy_wod" && item.partner === "world-of-dypians";
  // });

  // const chestTasks = tasks.filter((item) => {
  //   return item.type === "open_chest" && item.partner === "world-of-dypians";
  // });
  // const completedChestTasks = completedTasks.filter((item) => {
  //   return item.type === "open_chest" && item.partner === "world-of-dypians";
  // });

  // const allWodTasks = [...buyWodTasks, ...completedBuyWodTasks]
  // const allChestTasks = [...chestTasks, ...completedChestTasks]


  // const buyWodPartner = {
  //   title: "Buy WOD",
  //   id: "buy_wod",
  //   image: "world-of-dypians.svg",
  //   reward: allWodTasks.reduce((acc, item) => acc + item.reward, 0),
  // };


  // const openChestsPartner = {
  //   title: "Open Daily Chests",
  //   id: "open_chest",
  //   image: "open_chest.png",
  //   reward: allChestTasks.reduce((acc, item) => acc + item.reward, 0),
  // };


  // const partners = [
  //   {
  //     title: "World of Dypians",
  //     id: "world-of-dypians",
  //     completed: 81,
  //     image: "wodToken",
  //     reward: 250000,
  //   },
  //   {
  //     title: "Dypius",
  //     id: "dypius",
  //     completed: 60,
  //     image: "dypius",
  //     reward: 250000,
  //   },
  //   {
  //     title: "OpenFlux",
  //     id: "openflux",
  //     completed: 42,
  //     image: "openflux",
  //     reward: 250000,
  //   },
  //   {
  //     title: "Partner 1",
  //     id: "partner-1",
  //     completed: 35,
  //     image: null,
  //     reward: 250000,
  //   },
  //   {
  //     title: "Partner 2",
  //     id: "partner-2",
  //     completed: 18,
  //     image: null,
  //     reward: 250000,
  //   },
  //   {
  //     title: "Partner 3",
  //     id: "partner-3",
  //     completed: 100,
  //     image: null,
  //     reward: 250000,
  //   },
  //   {
  //     title: "Partner 4",
  //     id: "partner-4",
  //     completed: 100,
  //     image: null,
  //     reward: 250000,
  //   },
  // ];


  // const bitgetTasks = tasks.filter((item) => {
  //   return item.partner === "bitget";
  // });
  // const completedBitgetTasks = completedTasks.filter((item) => {
  //   return item.partner === "bitget";
  // });





  // const allBitgetTasks = [...bitgetTasks, ...completedBitgetTasks]




  // const bitgetPartner = {
  //   title: "BitGet Campaign",
  //   id: "bitget", 
  //   image: "bitget.svg",
  //   reward: allBitgetTasks.reduce((acc, item) => acc + item.reward, 0),
  // }



  return (
    <div className="container-fluid earn-wrapper pt-4 pb-3">
      <div className="d-flex flex-column gap-2 ">
        <h6 className="home-tasks-title mb-0">Earn</h6>
        <NavLink
          to={"/earn/daily-opportunities"}
          className={`daily-opportunities-wrapper p-3 d-flex w-100 justify-content-between align-items-center mb-4`}
        >
          <div className="d-flex flex-column gap-1">
            <span
              className="daily-opportunities-title"
              style={{ fontSize: "18px" }}
            >
              Daily Opportunities
            </span>
            <button className="earn-daily-button d-flex align-items-center gap-1 py-1">
              Earn now
              <img
                src={earnArrow}
                width={14}
                height={14}
                className="earn-arrow"
                alt="earnArrow"
              />
            </button>
          </div>
          <img src={sandTimer} alt="" />
        </NavLink>
        {/* <PartnerCard item={buyWodPartner} />
        <PartnerCard item={openChestsPartner} /> */}
        {/* <PartnerCard item={bitgetPartner} /> */}

        <div className="home-tasks-container mb-3 d-flex flex-column gap-2 position-relative">
          {wodTasks.map((task, index) => (
            <TaskItem
              item={task}
              key={index}
              handleCompleteTask={handleCompleteTask}
              page={"earn"}
            />
          ))}
          {filteredCompleted.map((task, index) => (
            <CompletedTaskItem item={task} key={index} page={"earn"} />
          ))}
        </div>
        {/* <h6 className="home-tasks-title mb-0">Partner Tasks</h6> */}

        {/* <div className="d-flex earn-partners-wrapper flex-column gap-2"> */}
        {/* {partners.map((item, index) => (
            <PartnerCard key={index} item={item} />
          ))} */}
        {/* <div className="d-flex w-100 align-items-center justify-content-center  flex-column mt-5">
                <h6 className="empty-title">Partner tasks are coming soon</h6>
                <h6 className="empty-title">Stay tuned!</h6>
              </div>
        </div> */}
      </div>
    </div>
  );
};

export default Earn;
